// src/components/core/MeetingController.js
import React, { useState, useEffect, useCallback } from 'react';
import LobbyScreen from '../meeting/LobbyScreen';
import PreJoinScreen from '../meeting/PreJoinScreen';
import RoomScreen from '../meeting/RoomScreen';
import { useGuestName } from '../../hooks/useGuestName';

const MeetingController = ({ meeting, user }) => {
    const [step, setStep] = useState('lobby');
    const [name, setName] = useGuestName();
    const [localStream, setLocalStream] = useState(null);
    
    // --- NEW: State to hold the chosen quality ---
    const [quality, setQuality] = useState('720p'); // Default quality

    const handleJoinLobby = useCallback((guestName) => {
        if (!user) {
            setName(guestName);
        }
        setStep('pre-join');
    }, [user, setName]);

    // --- UPDATED: Now accepts quality from PreJoinScreen ---
    const handleJoin = useCallback((stream, selectedQuality) => {
        if (stream) {
            setLocalStream(stream);
            setQuality(selectedQuality); // Save the selected quality
            setStep('room');
        } else {
            console.error("Attempted to join room without a valid media stream.");
            alert("Could not get your camera and microphone. Please check permissions.");
        }
    }, []);

    const handleCancelPreJoin = useCallback(() => {
        setStep('lobby');
    }, []);

    useEffect(() => {
        if (user) {
            setStep('pre-join');
        } else {
            setStep('lobby');
        }
    }, [user]);

    switch (step) {
        case 'lobby':
            return <LobbyScreen onJoin={handleJoinLobby} meetingDetails={meeting} />;
        case 'pre-join':
            return <PreJoinScreen onJoin={handleJoin} onCancel={handleCancelPreJoin} meeting={meeting} />;
        case 'room':
            // --- UPDATED: Pass the quality setting to the RoomScreen ---
            return <RoomScreen meeting={meeting} user={user} guestName={name} localStream={localStream} initialQuality={quality} />;
        default:
            return <div>An unexpected error occurred in the meeting flow.</div>;
    }
};

export default MeetingController;
